// extracted by mini-css-extract-plugin
module.exports = {"checkbox-container":"OfsIsViewed_checkbox-container__1Zjlt","button":"OfsIsViewed_button__395ua","center":"OfsIsViewed_center__2F6P9"};